/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_remaining_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time remaining`)
};

const es_timer_remaining_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo restante`)
};

const de_timer_remaining_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbleibende Zeit`)
};

const nl_timer_remaining_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resterende tijd`)
};

const fr_timer_remaining_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps restant`)
};

const it_timer_remaining_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo rimanente`)
};

const pt_br2_timer_remaining_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo restante`)
};

const pt_timer_remaining_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo restante`)
};

const ja_timer_remaining_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`残り時間`)
};

const zh_timer_remaining_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剩余时间`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_remaining_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_remaining_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_remaining_label", locale)
	if (locale === "en") return en_timer_remaining_label(inputs)
	if (locale === "es") return es_timer_remaining_label(inputs)
	if (locale === "de") return de_timer_remaining_label(inputs)
	if (locale === "nl") return nl_timer_remaining_label(inputs)
	if (locale === "fr") return fr_timer_remaining_label(inputs)
	if (locale === "it") return it_timer_remaining_label(inputs)
	if (locale === "pt-BR") return pt_br2_timer_remaining_label(inputs)
	if (locale === "pt") return pt_timer_remaining_label(inputs)
	if (locale === "ja") return ja_timer_remaining_label(inputs)
	return zh_timer_remaining_label(inputs)
};